import styled from 'styled-components';
import { borderRadius, colorUsage, fontSize, fontWeight, getSpacing, transitionDuration, zIndex } from 'stylesheet';
import { Edit, Plus, Trash } from 'theme/icons';
var IMAGE_CONTAINER_WIDTH = 400;
var ImageContainer = styled.div.withConfig({
  displayName: "ImageInputstyle__ImageContainer",
  componentId: "sc-q9jb58-0"
})(["display:flex;align-items:center;justify-content:center;width:", "px;height:", "px;margin-top:", ";"], IMAGE_CONTAINER_WIDTH, function (props) {
  return IMAGE_CONTAINER_WIDTH / props.ratio;
}, getSpacing(2));
var ImagePlaceholder = styled.div.withConfig({
  displayName: "ImageInputstyle__ImagePlaceholder",
  componentId: "sc-q9jb58-1"
})(["display:flex;flex:1;flex-direction:column;align-items:center;justify-content:center;width:100%;height:100%;color:", ";font-size:", ";white-space:pre;text-align:center;background-color:", ";border-color:", ";border-style:dashed;border-width:2px;border-radius:", ";outline:none;transition:border ", " ease-in-out;&:focus{border-color:", ";}&:hover{cursor:pointer;}"], colorUsage.dropzone.base.color, fontSize.small, colorUsage.dropzone.base.backgroundColor, colorUsage.dropzone.base.borderColor, borderRadius.medium, transitionDuration["default"], colorUsage.dropzone.active.borderColor);
var SizeInfo = styled.span.withConfig({
  displayName: "ImageInputstyle__SizeInfo",
  componentId: "sc-q9jb58-2"
})(["padding-left:", ";color:", ";font-weight:", ";"], getSpacing(1), colorUsage.textColorLight, fontWeight.normal);
var MaxSizeInfo = styled.span.withConfig({
  displayName: "ImageInputstyle__MaxSizeInfo",
  componentId: "sc-q9jb58-3"
})(["color:", ";font-size:", ";"], colorUsage.textColorLight, fontSize.smaller);
var PlusIcon = styled(Plus).withConfig({
  displayName: "ImageInputstyle__PlusIcon",
  componentId: "sc-q9jb58-4"
})(["margin:", ";path{fill:", ";}"], getSpacing(1), colorUsage.dropzone.base.color);
var EditIcon = styled(Edit).withConfig({
  displayName: "ImageInputstyle__EditIcon",
  componentId: "sc-q9jb58-5"
})(["path{fill:", ";}"], colorUsage.paletteOverride.primary.main);
var TrashIcon = styled(Trash).withConfig({
  displayName: "ImageInputstyle__TrashIcon",
  componentId: "sc-q9jb58-6"
})(["path{fill:", ";}"], colorUsage.paletteOverride.primary.main);
var HoverButtonContainer = styled.div.withConfig({
  displayName: "ImageInputstyle__HoverButtonContainer",
  componentId: "sc-q9jb58-7"
})(["position:absolute;top:42%;z-index:", ";display:flex;gap:", ";"], zIndex.buttonHover, getSpacing(3));
var Img = styled.img.withConfig({
  displayName: "ImageInputstyle__Img",
  componentId: "sc-q9jb58-8"
})(["max-width:100%;max-height:100%;opacity:", ";"], function (_ref) {
  var isHover = _ref.isHover;
  return isHover ? 0.6 : 1;
});
export { EditIcon, HoverButtonContainer, ImageContainer, ImagePlaceholder, Img, MaxSizeInfo, PlusIcon, SizeInfo, TrashIcon };